import { authApi } from '../api';
import { logger } from '../../utils/logger';
import {
  consumePkceSession,
  generateCodeChallenge,
  generateCodeVerifier,
  buildOidcState,
  storePkceSession,
} from './pkce.util';
import { getOidcRedirectUri, waitForOidcCallback } from './oidc-popup';
import { navigateOidcPopup } from './open-oidc-popup.util';
import { buildAuthorizeUrl } from './oidc-authorize.util';

export async function signInWithNiceOidc(
  sapHost: string,
  popup: Window
): Promise<{
  code: string;
  codeVerifier: string;
  redirectUri: string;
}> {
  const redirectUri = getOidcRedirectUri();
  const bootstrap = await authApi.getOidcBootstrap(sapHost, redirectUri);

  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  const state = buildOidcState(window.location.origin);

  storePkceSession({ codeVerifier, state, redirectUri });

  const authorizeUrl = buildAuthorizeUrl(bootstrap, codeChallenge, state);
  navigateOidcPopup(popup, authorizeUrl);

  const code = await waitForOidcCallback(popup, state);
  const pkceSession = consumePkceSession(state);

  if (!pkceSession) {
    logger.warn('[NICE OIDC] OAuth state mismatch or session expired');
    throw new Error('NICE sign-in session expired. Try again.');
  }

  return {
    code,
    codeVerifier: pkceSession.codeVerifier,
    redirectUri: pkceSession.redirectUri,
  };
}

export { getOidcRedirectUri } from './oidc-popup';
